import { useEffect, useState, useContext } from "react";
import "../categoriasFinanceiro/CategoriasFinanceiro.scss";
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import { Popconfirm } from "antd";
import ErrorIcon from "@mui/icons-material/Error";
import {
  Image,
  Receipt,
  FileText,
  LayoutTemplate,
  History,
} from "lucide-react";

import { useLoading } from "../../../shared/context/LoadingContext";
import toast from "react-hot-toast";
import ModalConfiguracoesAvaliacao from "./components/modalConfiguracoesAvaliacao/ModalConfiguracoesAvaliacao";
// import ModalConfiguracoesConsulta from "./components/modalConfiguracoesConsulta/ModalConfiguracoesConsulta";
import ModalConfiguracoesValidadeParcela from "./components/modalConfiguracoesValidadeParcela/ModalConfiguracoesValidadeParcela";
import ModalConfiguracoesTipoAgendamento from "./components/modalConfiguracoesTipoAgendamento/ModalConfiguracoesTipoAgendamento";
import ModalConfiguracoesValidadeOrcamento from "./components/modalConfiguracoesValidadeOrcamento/ModalConfiguracoesValidadeOrcamento";
import ModalConfiguracoesCabecalhoRodape from "./components/modalConfiguracoesCabecalhoRodape/ModalConfiguracoesCabecalhoRodape";
import ModalConfiguracoesModelosDocumentos from "./components/modalConfiguracoesModelosDocumentos/ModalConfiguracoesModelosDocumentos";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotaPartilhaUnidades from "../components/NotaPartilhaUnidades";

function Outras({ sendRequest, clinicaId }) {
  const { startLoading, stopLoading } = useLoading();

  const [modalData, setModalData] = useState();
  const [configuracao, setConfiguracao] = useState();
  const auth = useContext(AuthContext);
  /* O resto da aplicação lê as configurações daqui. Sem lhe dizer que mudaram,
     ligar um interruptor nesta página só fazia efeito nos outros ecrãs depois
     de recarregar — e quem acabou de o ligar vai logo experimentar. */
  const { setConfiguracoes } = useContext(ClinicaContext);
  const [dadosClinica, setDadosClinica] = useState();

  useEffect(() => {
    const fetchConfiguracoes = async () => {
      startLoading();
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/configuracoes/clinica/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        const responseData2 = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/clinicas/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setDadosClinica(responseData2.clinica);
        setConfiguracao(responseData.configuracao);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchConfiguracoes();
  }, [auth.token, clinicaId, sendRequest]);

  const handleModalClose = () => {
    setModalData(null);
  };

  const handleOpenModal = (modal) => {
    setModalData({ open: modal, ...(configuracao.configuracoes[modal] || {}) });
  };

  /* `campo` para as configurações com mais do que um interruptor. Sem ele o
     servidor mexe no `ativo`, que é o que todas as chamadas antigas esperam.
     ─── SÓ SE FOR TEXTO ──────────────────────────────────────────────────────
     O `onConfirm` do `Popconfirm` passa o EVENTO DO CLIQUE como argumento. Com
     `.bind(null, "nome")`, isto era chamado como
     `handleAtivarDesativar("nome", <MouseEvent>)` — e o `FormData.append`
     converte o evento em `"[object Object]"`, que o servidor recusa com
     «Campo inválido».
     Partia os CINCO interruptores deste ecrã desde que o parâmetro `campo`
     foi acrescentado; a importação de histórico foi só onde se deu por isso.
     Verificar o tipo aqui resolve para todas as chamadas, em vez de obrigar
     cada `bind` a saber do problema. */
  const handleAtivarDesativar = async (configuracao, campo) => {
    const campoValido = typeof campo === "string" ? campo : null;

    startLoading();
    try {
      const formDataDesativar = new FormData();
      formDataDesativar.append("utilizador", auth.userId);
      formDataDesativar.append("nomeConfiguracao", configuracao);
      if (campoValido) formDataDesativar.append("campo", campoValido);

      const resposta = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/configuracoes/ativardesativar/${clinicaId}`,
        "PATCH",
        formDataDesativar,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      setConfiguracao(resposta.configuracao);
      setConfiguracoes?.(resposta.configuracao);
      toast.success(resposta.message);
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
    }
  };

  const handleUpdate = (novaConfiguracao) => {
    setConfiguracao({ ...novaConfiguracao });
  };

  const handleUpdateCabecalhoRodape = (novosDadosClinica) => {
    setDadosClinica(novosDadosClinica);
  };
  return (
    <>
      <div className="categoriasGeral__container">
        <div
          style={{
            backgroundColor: "#e3f2fd",
            border: "1px solid #90caf9",
            borderRadius: "8px",
            padding: "16px 20px",
            marginBottom: "20px",
            display: "flex",
            gap: "15px",
            alignItems: "flex-start",
            gridColumn: "1/-1",
          }}
        >
          <InfoOutlinedIcon style={{ color: "#1976d2", marginTop: "2px" }} />
          <div
            style={{ fontSize: "14px", color: "#1565c0", lineHeight: "1.6" }}
          >
            <strong
              style={{
                display: "block",
                marginBottom: "8px",
                fontSize: "15px",
              }}
            >
              Configurações Gerais da Clínica
            </strong>
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              <li>
                <strong>Avaliação:</strong> Define se a clínica cobra por
                avaliações e o valor.
              </li>
              <li>
                <strong>Validade de Parcelas:</strong> Dias para pagamento antes
                de marcar como atrasada.
              </li>
              <li>
                <strong>Validade de Orçamentos:</strong> Prazo em dias até o
                orçamento expirar.
              </li>
              <li>
                <strong>Tipo de Agendamento:</strong> Escolha entre agendamento
                por tratamento ou por categoria.
              </li>
              <li>
                <strong>Impressão a Preto e Branco: </strong>
                Documentos impressos a preto e branco, com a excessão de
                assinaturas digitais nelas contida
              </li>
              <li>
                <strong>Modelos de Documentos:</strong> Escolha o layout visual
                para orçamentos, prescrições, atestados e impressos.
              </li>
              <li>
                <strong>Cabeçalho/Rodapé:</strong> Adicione imagens
                personalizadas aos orçamentos e planos de tratamento.
              </li>
              <NotaPartilhaUnidades />
            </ul>
          </div>
        </div>

        {configuracao && (
          <>
            <div
              className={`categoriasFinanceiro__container__categoria ${
                configuracao?.configuracoes?.avaliacao?.ativo === false
                  ? "despesasRecorrentes__desativado"
                  : ""
              }`}
            >
              {/* Avaliação */}
              <div className="categoriasFinanceiro__container__categoria--1">
                Avaliação
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <Popconfirm
                  title={`Desativar recebimento de Avaliação`}
                  description={`Pretende ${
                    configuracao?.configuracoes?.avaliacao?.ativo === true
                      ? "desativar"
                      : "ativar"
                  } a funcionalidade de recebimento de avaliação?`}
                  icon={<ErrorIcon style={{ color: "red" }} />}
                  okText="Sim"
                  cancelText="Não"
                  onConfirm={handleAtivarDesativar.bind(null, "avaliacao")}
                  className="popConfirm--biggerPadding"
                >
                  <span
                    style={{
                      color: configuracao?.configuracoes?.avaliacao?.ativo
                        ? "crimson"
                        : "#2e7d32",
                    }}
                  >
                    {configuracao?.configuracoes?.avaliacao?.ativo
                      ? "Desativar"
                      : "Ativar"}
                  </span>
                </Popconfirm>
                <span onClick={handleOpenModal.bind(null, "avaliacao")}>
                  Editar
                </span>
              </div>
            </div>
            <div className="categoriasFinanceiro__container__categoria">
              {/* Validade Parcelas */}
              <div className="categoriasFinanceiro__container__categoria--1">
                Validade de Parcelas
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <span onClick={handleOpenModal.bind(null, "validadeParcela")}>
                  Editar
                </span>
              </div>
            </div>

            <div className="categoriasFinanceiro__container__categoria">
              {/* Validade Orcamentos */}
              <div className="categoriasFinanceiro__container__categoria--1">
                Validade de Orçamentos
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <Popconfirm
                  title={`Desativar validade de Orçamentos`}
                  description={`Pretende ${
                    configuracao?.configuracoes?.validadeOrcamentos?.ativo ===
                    true
                      ? "desativar"
                      : "ativar"
                  } a funcionalidade de validade de orçamentos?`}
                  icon={<ErrorIcon style={{ color: "red" }} />}
                  okText="Sim"
                  cancelText="Não"
                  onConfirm={handleAtivarDesativar.bind(
                    null,
                    "validadeOrcamentos",
                  )}
                  className="popConfirm--biggerPadding"
                >
                  <span
                    style={{
                      color: configuracao?.configuracoes?.validadeOrcamentos
                        ?.ativo
                        ? "crimson"
                        : "#2e7d32",
                    }}
                  >
                    {configuracao?.configuracoes?.validadeOrcamentos?.ativo
                      ? "Desativar"
                      : "Ativar"}
                  </span>
                </Popconfirm>
                <span
                  onClick={handleOpenModal.bind(null, "validadeOrcamentos")}
                >
                  Editar
                </span>
              </div>
            </div>

            <div
              className={`categoriasFinanceiro__container__categoria ${
                configuracao?.configuracoes?.avaliacao?.ativo === false
                  ? "despesasRecorrentes__desativado"
                  : ""
              }`}
            >
              <div className="categoriasFinanceiro__container__categoria--1">
                Tipo de Agendamentos {"-> "}
                {configuracao?.configuracoes?.tipoAgendamento?.tipo}
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <span onClick={handleOpenModal.bind(null, "tipoAgendamento")}>
                  Editar
                </span>
              </div>
            </div>

            {/* Aqui estava «Categorias de Limpeza». Retirado em 2026-09-27: a
                escolha passou para cada tratamento, em Tratamentos → «Pede
                próxima limpeza?». Uma categoria de Prevenção tem a limpeza e
                tem o selante, e o selante não pede revisão daqui a seis
                meses. */}

            <div
              className={`categoriasFinanceiro__container__categoria ${
                configuracao?.configuracoes?.impressaoPretoEBranco?.ativo ===
                false
                  ? "despesasRecorrentes__desativado"
                  : ""
              }`}
            >
              <div className="categoriasFinanceiro__container__categoria--1">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Receipt size={18} />
                  <span>Impressão a Preto e Branco</span>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "4px",
                    marginLeft: "26px",
                  }}
                >
                  Documentos impressos sem cores, exceto assinaturas digitais
                </div>
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <Popconfirm
                  title="Impressão a Preto e Branco"
                  description={`Pretende ${
                    configuracao?.configuracoes?.impressaoPretoEBranco?.ativo
                      ? "desativar"
                      : "ativar"
                  } a impressão a preto e branco?`}
                  icon={<ErrorIcon style={{ color: "red" }} />}
                  okText="Sim"
                  cancelText="Não"
                  onConfirm={handleAtivarDesativar.bind(
                    null,
                    "impressaoPretoEBranco",
                  )}
                >
                  <span
                    style={{
                      color: configuracao?.configuracoes?.impressaoPretoEBranco
                        ?.ativo
                        ? "crimson"
                        : "#2e7d32",
                    }}
                  >
                    {configuracao?.configuracoes?.impressaoPretoEBranco?.ativo
                      ? "Desativar"
                      : "Ativar"}
                  </span>
                </Popconfirm>
              </div>
            </div>

            {/* Importação de histórico em papel. Desligado por omissão: é uma
                ferramenta de quem está a passar fichas antigas para o sistema,
                e numa clínica em funcionamento normal seria uma segunda porta
                para registar trabalho de hoje com a data de outro dia. */}
            <div
              className={`categoriasFinanceiro__container__categoria ${
                configuracao?.configuracoes?.importacaoHistorico?.ativo === false
                  ? "despesasRecorrentes__desativado"
                  : ""
              }`}
            >
              <div className="categoriasFinanceiro__container__categoria--1">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <History size={18} />
                  <span>Importação de Histórico</span>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "4px",
                    marginLeft: "26px",
                  }}
                >
                  Permite lançar na ficha do paciente tratamentos já feitos em
                  papel, cada um com a sua data e o seu dentista. Não gera
                  dívida nem desconta stock, e fica marcado como histórico
                  importado. Desligue quando a migração terminar.
                </div>
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <Popconfirm
                  title="Importação de Histórico"
                  description={`Pretende ${
                    configuracao?.configuracoes?.importacaoHistorico?.ativo
                      ? "desativar"
                      : "ativar"
                  } a importação de histórico em papel?`}
                  icon={<ErrorIcon style={{ color: "red" }} />}
                  okText="Sim"
                  cancelText="Não"
                  onConfirm={handleAtivarDesativar.bind(
                    null,
                    "importacaoHistorico",
                  )}
                >
                  <span
                    style={{
                      color: configuracao?.configuracoes?.importacaoHistorico
                        ?.ativo
                        ? "crimson"
                        : "#2e7d32",
                    }}
                  >
                    {configuracao?.configuracoes?.importacaoHistorico?.ativo
                      ? "Desativar"
                      : "Ativar"}
                  </span>
                </Popconfirm>
              </div>
            </div>

            {/* Só faz sentido enquanto a importação estiver ligada: sem ela,
                ninguém importa, seja qual for o perfil. */}
            {configuracao?.configuracoes?.importacaoHistorico?.ativo && (
              <div className="categoriasFinanceiro__container__categoria">
                <div className="categoriasFinanceiro__container__categoria--1">
                  Secretárias podem importar histórico {"-> "}
                  {configuracao?.configuracoes?.importacaoHistorico
                    ?.secretariaPode
                    ? "Sim"
                    : "Não"}
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#666",
                      marginTop: "4px",
                    }}
                  >
                    Por omissão só o dentista e o médico/administrador importam
                    histórico. Ligue se for a secretária a fazer a digitação das
                    fichas em papel.
                  </div>
                </div>
                <div className="categoriasFinanceiro__container__categoria--2">
                  <Popconfirm
                    title="Importação por secretárias"
                    description={`Pretende ${
                      configuracao?.configuracoes?.importacaoHistorico
                        ?.secretariaPode
                        ? "retirar"
                        : "dar"
                    } às secretárias a permissão de importar histórico?`}
                    icon={<ErrorIcon style={{ color: "red" }} />}
                    okText="Sim"
                    cancelText="Não"
                    onConfirm={handleAtivarDesativar.bind(
                      null,
                      "importacaoHistorico",
                      "secretariaPode",
                    )}
                  >
                    <span
                      style={{
                        color: configuracao?.configuracoes?.importacaoHistorico
                          ?.secretariaPode
                          ? "crimson"
                          : "#2e7d32",
                      }}
                    >
                      {configuracao?.configuracoes?.importacaoHistorico
                        ?.secretariaPode
                        ? "Retirar"
                        : "Permitir"}
                    </span>
                  </Popconfirm>
                </div>
              </div>
            )}

            <div className="categoriasFinanceiro__container__categoria">
              <div className="categoriasFinanceiro__container__categoria--1">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <LayoutTemplate size={18} />
                  <span>Modelos de Documentos</span>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "4px",
                    marginLeft: "26px",
                  }}
                >
                  Orçamento: {configuracao?.configuracoes?.modelosDocumentos?.orcamento || "modelo1"} &bull;{" "}
                  Prescrição: {configuracao?.configuracoes?.modelosDocumentos?.prescricao || "modelo1"} &bull;{" "}
                  Atestado: {configuracao?.configuracoes?.modelosDocumentos?.atestado || "modelo1"} &bull;{" "}
                  Impresso: {configuracao?.configuracoes?.modelosDocumentos?.impresso || "modelo1"}
                </div>
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <span onClick={handleOpenModal.bind(null, "modelosDocumentos")}>
                  Editar
                </span>
              </div>
            </div>

            <div className="categoriasFinanceiro__container__categoria">
              <div className="categoriasFinanceiro__container__categoria--1">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  <Image size={18} />
                  <span>Cabeçalho e Rodapé de Documentos</span>
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    marginTop: "4px",
                    marginLeft: "26px",
                  }}
                >
                  {dadosClinica?.cabecalhoRodape?.orcamentoParticular && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                      }}
                    >
                      <Receipt size={12} /> Orçamentos Particular ✓
                    </span>
                  )}
                  {dadosClinica?.cabecalhoRodape?.orcamentoSegurado && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        marginTop: "2px",
                      }}
                    >
                      <Receipt size={12} /> Orçamentos Segurado ✓
                    </span>
                  )}
                  {dadosClinica?.cabecalhoRodape?.planoTratamento && (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        marginTop: "2px",
                      }}
                    >
                      <FileText size={12} /> Planos de Tratamento ✓
                    </span>
                  )}
                  {!dadosClinica?.cabecalhoRodape?.orcamentoParticular &&
                    !dadosClinica?.cabecalhoRodape?.orcamentoSegurado &&
                    !dadosClinica?.cabecalhoRodape?.planoTratamento &&
                    "Nenhum documento ativo"}
                </div>
              </div>
              <div className="categoriasFinanceiro__container__categoria--2">
                <span onClick={handleOpenModal.bind(null, "cabecalhoRodape")}>
                  Editar
                </span>
              </div>
            </div>
          </>
        )}
      </div>

      {modalData?.open === "avaliacao" && (
        <ModalConfiguracoesAvaliacao
          openModal={modalData.open === "avaliacao"}
          handleModalClose={handleModalClose}
          modalData={modalData}
          handleUpdate={handleUpdate}
          sendRequest={sendRequest}
          clinicaId={clinicaId}
          auth={auth}
        />
      )}

      {modalData?.open === "validadeParcela" && (
        <ModalConfiguracoesValidadeParcela
          openModal={modalData.open === "validadeParcela"}
          handleModalClose={handleModalClose}
          modalData={modalData}
          handleUpdate={handleUpdate}
          sendRequest={sendRequest}
          clinicaId={clinicaId}
          auth={auth}
        />
      )}

      {modalData?.open === "validadeOrcamentos" && (
        <ModalConfiguracoesValidadeOrcamento
          openModal={modalData.open === "validadeOrcamentos"}
          handleModalClose={handleModalClose}
          modalData={modalData}
          handleUpdate={handleUpdate}
          sendRequest={sendRequest}
          clinicaId={clinicaId}
          auth={auth}
        />
      )}

      {modalData?.open === "tipoAgendamento" && (
        <ModalConfiguracoesTipoAgendamento
          openModal={modalData.open === "tipoAgendamento"}
          handleModalClose={handleModalClose}
          modalData={modalData}
          handleUpdate={handleUpdate}
          sendRequest={sendRequest}
          clinicaId={clinicaId}
          auth={auth}
        />
      )}


      {modalData?.open === "modelosDocumentos" && (
        <ModalConfiguracoesModelosDocumentos
          openModal={modalData.open === "modelosDocumentos"}
          handleModalClose={handleModalClose}
          modalData={modalData}
          handleUpdate={handleUpdate}
          sendRequest={sendRequest}
          clinicaId={clinicaId}
          auth={auth}
        />
      )}

      {modalData?.open === "cabecalhoRodape" && (
        <ModalConfiguracoesCabecalhoRodape
          openModal={modalData.open === "cabecalhoRodape"}
          handleModalClose={handleModalClose}
          modalData={modalData}
          handleUpdateCabecalhoRodape={handleUpdateCabecalhoRodape}
          sendRequest={sendRequest}
          clinicaId={clinicaId}
          auth={auth}
          dadosClinica={dadosClinica}
        />
      )}
    </>
  );
}

export default Outras;
